import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LABEL_TABS, LabelsPage } from "@/features/labels/labels-page";

export const Route = createFileRoute("/labels")({
  validateSearch: z.object({ tab: z.enum(LABEL_TABS).optional() }),
  component: LabelsRoute,
});

function LabelsRoute() {
  const { tab = "basket" } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LabelsPage
      tab={tab}
      onTab={(next) => void navigate({ search: next === "basket" ? {} : { tab: next } })}
    />
  );
}
